/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Field_Dvc_SearchInputs */

const en_task_field_dvc_search = /** @type {(inputs: Task_Field_Dvc_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DVC search`)
};

const pt_br2_task_field_dvc_search = /** @type {(inputs: Task_Field_Dvc_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busca DVC`)
};

/**
* | output |
* | --- |
* | "DVC search" |
*
* @param {Task_Field_Dvc_SearchInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_field_dvc_search = /** @type {((inputs?: Task_Field_Dvc_SearchInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Field_Dvc_SearchInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_field_dvc_search(inputs)
	return pt_br2_task_field_dvc_search(inputs)
});